
export const airtableOps = "https://europe-west1-kaiserpartner-webshop.cloudfunctions.net/airtable-ops";//"http://localhost:8085/"